import {Box} from '~/CreateFabricInvitation/components/Box/Box';
import {EditorGroup} from '~/CreateFabricInvitation/components/EditorGroup/EditorGroup';
import {EditorResetHeader} from '~/CreateFabricInvitation/components/EditorHeader/EditorResetHeader';
import {EditBox} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/EditBox/EditBox';
import {EditorIcons} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/EditorIcons/EditorIcons';
import {useOverlay} from '~/common/OverlayAnimation/actions/useOverlay';

import './RevealEditor.sass';

export const RevealEditor = () => {
  const {onOverlayChange, onOverlayReset, overlayIcons, selectedOverlay, hasOverlayChanged} =
    useOverlay(false, true);

  return (
    <div className="reveal-editor">
      <EditBox className="reveal-editor__content">
        <EditorGroup>
          <EditorResetHeader
            title="Reveals"
            onReset={onOverlayReset}
            dataQaId="step1-reveals-reset"
            enabled={hasOverlayChanged}
          />
          <Box className="reveal-editor__box" height="16rem">
            <EditorIcons
              icons={overlayIcons}
              selectedIcon={selectedOverlay}
              onClick={onOverlayChange}
              height={64}
              width={50}
              hideAnimatedIndicator
              outline
            />
          </Box>
        </EditorGroup>
      </EditBox>
    </div>
  );
};
